export default "__VITE_ASSET__c892ae7b__"